import axios from 'axios';
import qs from 'qs';
import { apiUrl } from '../constants/common';

const API = {
  instance: axios.create({
    baseURL: apiUrl,
    withCredentials: true
  }),
  // 设置token
  setToken(token) {
    this.instance.defaults.headers.common['Authorization'] = token;
  },

  // 登录
  getH5Login(params) {
    return this.instance.get('/h5/login', {
      params: params
    });
  },

  // 获取用户信息
  getH5Info() {
    return this.instance.get('/h5/info');
  },

  // 抽奖
  postH5Lottery() {
    return this.instance.post('/h5/lottery');
  },

  // 获取微信批量添加卡券的签名
  getH5CardExt() {
    return this.instance.get('/h5/card_ext');
  },

  // 获取活动状态
  getH5Status() {
    return this.instance.get('/h5/status');
  },

  getH5Ping() {
    return this.instance.get('/h5/ping');
  },

  // 临时：清除自身数据
  getUtilsClearOne() {
    return this.instance.get('/utils/clear_one');
  }
};

API.instance.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded';

// axios拦截
// axios 全局配置（拦截所有请求）
API.instance.interceptors.request.use(
  req => {
    if (req.method.toLowerCase() === 'get') {
      req.params = req.params || {};
      req.params['t'] = Date.now();
    }
    if (req.method.toLowerCase() === 'post') {
      req.data = qs.stringify(req.data);
    }
    return req;
  },
  /* eslint-disable handle-callback-err */
  err => {
    return Promise.reject(err);
  }
);

// axios 全局配置（拦截所有响应）
API.instance.interceptors.response.use(
  res => {
    if (/\/h5\/ping/.test(res.config.url)) {
      if (res.status === 200) {
        return Promise.resolve({ ok: true });
      }
      if (res.status === 503) {
        return Promise.reject({ ok: false, limited: true });
      }
      return Promise.reject({ ok: false, limited: false });
    }
    if (res.data.ok !== true) {
      // 服务器请求出错
      if (res.status === 503) {
        return Promise.reject({
          data: res.data,
          limited: true
        });
      }
      return Promise.reject({
        data: res.data,
        limited: false
      });
    }
    return Promise.resolve(res.data);
  },
  err => {
    if (axios.isCancel(err)) {
      console.log(err.message);
    }
    if(err.response.status === 503){
      return Promise.reject({
        err:err,
        limited:true,
      })
    }
    return Promise.reject({
      err:err,
      limited:false
    });
  }
);

// 请求超时
API.instance.defaults.timeout = 8000;

export default API;
